<template>
    <!--新增MCP -->
    <vxe-modal
        v-model="formInput.isShow"
        @close="closeWinEvent"
        :title="formInput.title"
        width="840"
        height="610"
        show-zoom
        remember
        resize
        show-footer
    >
        <template #default>
            <a-tabs
                :key="tabsKey"
                v-model:activeKey="activeTab"
                type="card"
                :destroyInactiveTabPane="false"
            >
                <a-tab-pane key="comInfo" tab="基本信息">
                    <vxe-form
                        :data="formInput.formData"
                        :rules="formInput.formRules"
                        title-align="right"
                        ref="rForm"
                        title-width="60"
                    >
                        <vxe-form-item
                            title="应用类别"
                            field="appClassId"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-select
                                    transfer
                                    v-model="formInput.formData.appClassId"
                                    :options="appClassList"
                                    placeholder="请选择应用类别"
                                    :disabled="formInput.allInputDisable"
                                    @change="onClassChange"
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            title="应用名称"
                            field="appName"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.appName"
                                    placeholder="请输入应用名称"
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="应用简介"
                            field="appDesc"
                            span="24"
                            title-width="120px"
                        >
                            <vxe-textarea
                                v-model="formInput.formData.appDesc"
                                placeholder="不超过1000个字"
                                maxlength="1000"
                                show-word-count
                                :disabled="formInput.allInputDisable"
                            ></vxe-textarea>
                        </vxe-form-item>

                        <vxe-form-item
                            title="标签"
                            field="labelId"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.labelId"
                                    :options="labels"
                                    placeholder="请选择标签"
                                    :disabled="formInput.allInputDisable"
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="应用图标"
                            field="fPathPhoto"
                            span="10"
                            title-width="120px"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.fPathPhoto"
                                    placeholder=""
                                    readonly
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item span="2">
                            <template #default>
                                <vxe-button
                                    @click="insertPhotoEvent"
                                    :disabled="formInput.allInputDisable"
                                    >浏览</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="MCP服务英文名"
                            field="mcpServeName"
                            span="12"
                            title-width="130px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.mcpServeName"
                                    placeholder="mcp-server-template"
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="开启远程服务"
                            field="isRemote"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-select
                                    transfer
                                    v-model="formInput.formData.isRemote"
                                    placeholder="请选择是否开启远程服务"
                                    :options="[
                                        { label: '是', value: '1' },
                                        { label: '否', value: '0' },
                                    ]"
                                    :disabled="formInput.allInputDisable"
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="公开范围"
                            field="publicRange"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.publicRange"
                                    placeholder="请选择发公开范围"
                                    :disabled="formInput.allInputDisable"
                                    empty-value=""
                                    @change="onPublicRangeChange"
                                    @clear="formInput.formData.publicRange = ''"
                                >
                                    <vxe-option
                                        value="1"
                                        label="个人"
                                    ></vxe-option>
                                    <vxe-option
                                        value="2"
                                        label="总部"
                                    ></vxe-option>
                                    <vxe-option
                                        value="3"
                                        label="全部"
                                    ></vxe-option>
                                </vxe-select>
                            </template>
                        </vxe-form-item>

                        <vxe-form-item
                            :visible="formInput.formData.publicRange === '2'"
                            title="公开总部"
                            field="publicDivision"
                            span="12"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-select
                                    v-model="formInput.formData.publicDivision"
                                    placeholder="请选择公开总部"
                                    :disabled="formInput.allInputDisable"
                                    clearable
                                    multiple
                                    empty-value=""
                                    @clear="
                                        formInput.formData.publicDivision = ''
                                    "
                                    :options="formInput.hqOptions"
                                >
                                </vxe-select>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            :visible="formInput.formData.publicRange === '1'"
                            title="公开个人"
                            field="pulicUser"
                            span="10"
                            title-width="120px"
                        >
                            <template #default>
                                <vxe-input
                                    v-model="formInput.formData.UserNameEmail"
                                    readonly
                                    placeholder="请选择公开个人"
                                    :disabled="formInput.allInputDisable"
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            span="2"
                            :visible="formInput.formData.publicRange === '1'"
                        >
                            <template #default>
                                <vxe-button
                                    @click="selectUser(1)"
                                    :disabled="formInput.allInputDisable"
                                    >选择</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item
                            title="附件信息"
                            span="24"
                            title-align="left"
                            title-width="200px"
                            :title-prefix="{ icon: 'fa fa-paperclip' }"
                        ></vxe-form-item>
                        <vxe-form-item
                            title="程序包"
                            field="fPathPackage"
                            span="18"
                            :item-render="{}"
                            title-width="120px"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.fPathPackage"
                                    placeholder="请选择程序包"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="" span="2" :item-render="{}">
                            <template #default="">
                                <vxe-button
                                    :disabled="!showFileEdit"
                                    @click="insertPackageEvent"
                                    >浏览</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="" span="4" :item-render="{}">
                            <a
                                v-if="isShowPackageLink"
                                href="javascript:void(0);"
                                @click="downloadFile(1)"
                                >下载</a
                            >
                        </vxe-form-item>
                        <vxe-form-item
                            title="说明文档"
                            field="fPathPdd"
                            span="18"
                            :item-render="{}"
                            title-width="120px"
                        >
                            <template #default="{ data }">
                                <vxe-input
                                    v-model="data.fPathPdd"
                                    placeholder="请选择设计文档"
                                    readonly
                                ></vxe-input>
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="" span="2" :item-render="{}">
                            <template #default="">
                                <vxe-button
                                    :disabled="!showFileEdit"
                                    @click="insertPDDEvent"
                                    >浏览</vxe-button
                                >
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="" span="2" :item-render="{}">
                            <a
                                v-if="isShowPDDLink"
                                href="javascript:void(0);"
                                @click="downloadFile(2)"
                                >下载</a
                            >
                        </vxe-form-item>
                        <vxe-form-item title="" span="2" :item-render="{}">
                            <a
                                v-if="!isShowPDDLink"
                                href="javascript:void(0);"
                                @click="downloadFile(4)"
                                >模板</a
                            >
                        </vxe-form-item>
                    </vxe-form>
                    <div
                        style="
                            text-align: center;
                            width: 100%;
                            margin-top: 30px;
                            gap: 30px;
                        "
                    >
                        <vxe-button
                            :loading="submitting"
                            @click="save"
                            icon="fa fa-save"
                            status="success"
                            >保存
                        </vxe-button>
                        <vxe-button
                            :loading="submitting"
                            @click="submit"
                            icon="fa fa-check"
                            status="primary"
                            >提交
                        </vxe-button>
                    </div></a-tab-pane
                >
                <a-tab-pane key="comVersion" tab="版本信息" v-if="showVersion">
                    <div>
                        <comVersion
                            :appId="formInput.formData.Id"
                            :isShowUpload="true"
                            :key="formInput.formData.Id + '-version'"
                        />
                    </div>
                </a-tab-pane>
            </a-tabs>
        </template>
        <template #footer v-if="isViewFooter"> </template>
    </vxe-modal>
    <vxe-modal title="选择用户" v-model="iShowSelectUser" width="640">
        <template #default>
            <div>
                <vxe-form :data="userTablePager">
                    <vxe-form-item
                        title="关键字"
                        field="searchKey"
                        :item-render="{}"
                    >
                        <template #default="{ data }">
                            <vxe-input
                                v-model="data.searchKey"
                                placeholder="请输入姓名或邮箱"
                                clearable
                            ></vxe-input>
                        </template>
                    </vxe-form-item>
                    <vxe-form-item>
                        <template #default>
                            <vxe-button
                                @click="findUserData"
                                @keyup.enter="findUserData"
                                >查询</vxe-button
                            >
                        </template>
                    </vxe-form-item>
                    <vxe-form-item>
                        <template #default>
                            <vxe-button
                                status="primary"
                                @click="confirmSelectUser"
                                >确定</vxe-button
                            >
                        </template>
                    </vxe-form-item>
                    <vxe-form-item span="24">
                        <template #title>
                            <span>已选(</span
                            ><span style="color: red">双击选择</span
                            ><span>)</span>
                        </template>
                        <template #default>
                            <div if="formInput.userSelType == 1">
                                <template
                                    v-for="(item, index) in formInput.formData
                                        .UserIDName"
                                    :key="index"
                                >
                                    <span>{{ item.Name }}</span>
                                    <va-icon
                                        class="icon-left input-icon"
                                        @click="clearUser(item.ID)"
                                        name="clear"
                                    />
                                </template>
                            </div>
                        </template>
                    </vxe-form-item>
                </vxe-form>
            </div>
            <div>
                <vxe-table
                    class="mytable-scrollbar"
                    :data="dtUser"
                    ref="xTableUser"
                    height="300"
                    @cell-dblclick="chooseUser"
                    highlight-hover-row
                    highlight-current-row
                >
                    <vxe-column
                        type="seq"
                        field="Uid"
                        title="序号"
                        width="50"
                    ></vxe-column>
                    <vxe-column
                        field="UserName"
                        title="姓名"
                        width="120"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="JobZb"
                        title="总部"
                        width="100"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="JobName"
                        title="部门"
                        width="120"
                        show-overflow
                        sortable
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="UserMail"
                        title="邮箱"
                        width="200"
                        sortable
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="Id"
                        title="Id"
                        width="10"
                        :visible="false"
                    ></vxe-column>
                </vxe-table>
            </div>
            <div>
                <vxe-pager
                    background
                    v-model:current-page="userTablePager.currentPage"
                    v-model:page-size="userTablePager.pageSize"
                    :total="userTablePager.totalResult"
                    @page-change="userListPageChange"
                    size="small"
                >
                </vxe-pager>
            </div>
        </template>
    </vxe-modal>
</template>

<script setup>
import {
    onMounted,
    reactive,
    ref,
    getCurrentInstance,
    defineExpose,
    defineEmits,
    nextTick,
    onActivated,
    watch,
} from "vue";
import { useRouter } from "vue-router";
import { VXETable } from "vxe-table";
import Qs from "qs";
import comVersion from "./comVersion.vue";
import { ConsoleSqlOutlined } from "@ant-design/icons-vue";

const router = useRouter();
const { proxy } = getCurrentInstance();
//
let rawDataClass = reactive([]);
const activeTab = ref("comInfo");
const showVersion = ref(false); //是否显示版本信息tab
const showFileEdit = ref(false); //是否显示附件编辑
const userTablePager = reactive({
    currentPage: 1,
    pageSize: 10,
    totalResult: 0,
    searchKey: "",
});
const formInput = reactive({
    title: "新增应用",
    isShow: false,
    saveButDisable: false,
    allInputDisable: false,
    userSelType: "1", //1 个人
    hqOptions: [],
    formData: {
        Id: "",
        status: "0",
        appName: "",
        appDesc: "",
        appIcon: "",
        mcpServeName: "",
        isRemote: "",
        creatorUID: "",
        CreateMan: "",
        creationTime: "",
        appClassId: null,
        labelId: null,
        fPathPackage: "",
        publicRange: "",
        publicDivision: "",
        publicUser: "",
        UserName: "",
        UserNameEmail: "",
        UserId: "", //pulicUser
        UserIDName: [],
    },
    formRules: {
        appName: [{ required: true, message: "应用名称不能为空" }],
        appDesc: [{ required: true, message: "应用简介不能为空" }],
        appIcon: [{ required: false, message: "应用图标不能为空" }],
        mcpServeName: [{ required: true, message: "MCP服务英文名不能为空" }],
        isRemote: [{ required: true, message: "开启远程服务不能为空" }],
        appClassId: [{ required: true, message: "应用类别不能为空" }],
        labelId: [{ required: true, message: "标签不能为空" }],
        publicRange: [{ required: true, message: "公开范围不能为空" }],
        publicDivision: [{ required: false, message: "公开总部不能为空" }],
        UserNameEmail: [{ required: false, message: "公开个人不能为空" }],
    },
});
let onePackageFile = ref({}); //上传的附件
let isShowPackageLink = ref(false);
let onePDDFile = ref({}); //上传的附件
let isShowPDDLink = ref(false);
let onePhotoFile = ref({}); //上传的附件
let isShowPhotoLink = ref(false);
let submitting = ref(false);
let isViewFooter = ref(true);
let editType = ref("1");
const rForm = ref(null);
let labelMap = ref({});
const iShowSelectUser = ref(false);
const emit = defineEmits(["flashIndex"]);
const dtUser = ref([]);
const xTableUser = ref(null);

const labels = ref([]); //标签
const appClassList = ref([]); //应用类型
const closeWinEvent = () => {
    emit("flashIndex");
};
const bindHQ = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 50,
        searchKey: [""],
    };
    proxy.$api.digitalDictManageAPI
        .getHeadquarterList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                console.log(res.data.Message);
                return;
            }
            // console.log(res.data.Data);
            formInput.hqOptions = [];
            for (const item of res.data.Data.dataTable) {
                formInput.hqOptions.push({
                    value: item.hqCode,
                    label: item.hqName,
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
const bindClassLabel = async () => {
    try {
        const params = {
            uid: proxy.$store.state.userID,
            email: proxy.$store.state.email,
            currentPage: 1,
            pageSize: 100,
            searchKey: [],
        };

        const { data } = await proxy.$api.componentManageAPI.getComClassLabel(
            Qs.stringify(params)
        );

        if (!data.Success) {
            VXETable.modal.message({
                content: data.Message,
                status: "error",
            });
            return;
        }

        const rawDataClass = data.Data.dataTable || [];

        // 构建分类下拉选项（去重）
        appClassList.value = [
            ...new Map(
                rawDataClass.map((item) => [
                    String(item.ClassId),
                    { label: item.ClassName, value: String(item.ClassId) },
                ])
            ).values(),
        ];

        // 构建 labelMap（分类 -> 标签）
        const map = {};
        rawDataClass.forEach(({ ClassId, LabelId, LabelName }) => {
            const key = String(ClassId);
            if (!map[key]) {
                map[key] = [];
            }
            map[key].push({ label: LabelName, value: String(LabelId) });
        });
        labelMap.value = map;
    } catch (error) {
        console.error("bindClassLabel error:", error);
    }
};
const findUserData = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: userTablePager.currentPage,
        pageSize: userTablePager.pageSize,
        searchKey: [userTablePager.searchKey],
    };
    proxy.$api.systemManageAPI
        .getUserList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            dtUser.value = res.data.Data.dataTable;
            userTablePager.currentPage = res.data.Data.currentPage;
            userTablePager.pageSize = res.data.Data.pageSize;
            userTablePager.totalResult = res.data.Data.totalResult;
        })
        .catch((error) => {
            console.log(error);
        });
};
const selectUser = (type) => {
    formInput.userSelType = type;
    findUserData();
    iShowSelectUser.value = true;
};
const userListPageChange = () => {
    findUserData();
};
const confirmSelectUser = () => {
    iShowSelectUser.value = false;
};
//选择用户
const chooseUser = () => {
    debugger;
    const $table = xTableUser.value;
    const record = $table.getCurrentRecord();
    if (!record) {
        VXETable.modal.message({ content: "请选择一行数据", status: "info" });
        return;
    }
    //选公开个人
    if (formInput.userSelType === 1) {
        //判断是否已选择过
        if (formInput.formData.UserId.toString() != "") {
            for (let item of formInput.formData.UserId.toString().split(";")) {
                if (item == record.Id) {
                    VXETable.modal.message({
                        content: "该人员已选择",
                        status: "warning",
                    });
                    return;
                }
            }
        }

        if (
            formInput.formData.UserNameEmail == null ||
            formInput.formData.UserNameEmail == ""
        ) {
            formInput.formData.UserNameEmail =
                record.UserName + "(" + record.UserMail + ")";
        } else {
            formInput.formData.UserNameEmail +=
                ";" + record.UserName + "(" + record.UserMail + ")";
        }
        if (
            formInput.formData.UserId == null ||
            formInput.formData.UserId == ""
        ) {
            formInput.formData.UserId = record.Id;
        } else {
            formInput.formData.UserId += ";" + record.Id;
        }
        let count = formInput.formData.UserId.toString().split(";").length;
        formInput.formData.UserIDName = [];
        for (let i = 0; i < count; i++) {
            formInput.formData.UserIDName.push({
                Name: formInput.formData.UserNameEmail.toString().split(";")[i],
                ID: formInput.formData.UserId.toString().split(";")[i],
            });
        }
    }
};
//新增
const addAPP = async () => {
    formInput.formData = {
        Id: proxy.$utils.guid(),
        status: "0",
        appName: "",
        appDesc: "",
        appIcon: "",
        mcpServeName: "",
        isRemote: "0",
        creatorUID: proxy.$store.state.userID,
        CreateMan: proxy.$store.state.userName,
        appClassId: "1",
        labelId: "",
        fPathPackage: "",
        fPathPdd: "",
        fPathPhoto: "",
        publicRange: "",
        publicDivision: "",
        UserName: "",
        UserNameEmail: "",
        UserId: "", //pulicUser
        UserIDName: [],
    };
    editType.value = "1"; //新增

    onePhotoFile.value = {};
    onePDDFile.value = {};
    onePackageFile.value = {};
    submitting.value = false;
    isShowPackageLink.value = false;
    isShowPDDLink.value = false;
    isShowPhotoLink.value = false;
    formInput.allInputDisable = false;
    formInput.saveButDisable = false;
    isViewFooter.value = true;
    // 根据当前分类选择标签
    const currentClassId = String(formInput.formData.appClassId || "");
    labels.value = labelMap.value[currentClassId] || [];
    formInput.title = "新增应用";
    activeTab.value = "comInfo";
    showVersion.value = false;
    showFileEdit.value = true;
    formInput.isShow = true;
    await nextTick();
    if (rForm.value) {
        try {
            rForm.value.reset();
        } catch (error) {
            console.error("rForm reset error:", error);
        }
    }
};

const getModel = () => {
    const data = new FormData();
    data.append("filePackage", onePackageFile.value);
    data.append("filePdd", onePDDFile.value);
    data.append("filePhoto", onePhotoFile.value);
    data.append("fPathPackage", formInput.formData.fPathPackage);
    data.append("fPathPdd", formInput.formData.fPathPdd);
    data.append("fPathPhoto", formInput.formData.fPathPhoto);
    data.append("Id", formInput.formData.Id);
    data.append("status", formInput.formData.status);
    data.append("appName", formInput.formData.appName);
    data.append("appDesc", formInput.formData.appDesc);
    data.append("appIcon", formInput.formData.fPathPhoto);
    data.append("mcpServeName", formInput.formData.mcpServeName);
    data.append("isRemote", formInput.formData.isRemote);
    data.append("creatorUID", formInput.formData.creatorUID);
    data.append("appClassId", formInput.formData.appClassId);
    data.append("labelId", formInput.formData.labelId);
    data.append("publicRange", formInput.formData.publicRange);
    data.append("publicDivision", formInput.formData.publicDivision);
    data.append("publicUser", formInput.formData.UserId); //publicUser
    data.append("modifier", proxy.$store.state.userID);

    return data;
};

//保存流程
const save = async () => {
    const $rForm = rForm.value;
    const formErrMap = await $rForm.validate();
    if (formErrMap) {
        return;
    }

    const data = getModel();
    submitting.value = true;
    //新增
    if (editType.value === "1") {
        proxy.$api.componentManageAPI
            .addAPP(data)
            .then((res) => {
                if (res.data.Success == false) {
                    submitting.value = false;
                    VXETable.modal.alert({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                editType.value = "2"; //新增后是修改
                showVersion.value = true;
                submitting.value = false;
                VXETable.modal.message({
                    content: "保存成功",
                    status: "success",
                });
            })
            .catch((error) => {
                submitting.value = false;
                VXETable.modal.alert({ content: error, status: "error" });
                console.log(error);
            });
    } else if (editType.value === "2") {
        //更新
        proxy.$api.componentManageAPI
            .updateAPP(data)
            .then((res) => {
                if (res.data.Success == false) {
                    submitting.value = false;
                    VXETable.modal.alert({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                editType.value = "2"; //
                showVersion.value = true;
                submitting.value = false;
                VXETable.modal.message({
                    content: "保存成功",
                    status: "success",
                });
            })
            .catch((error) => {
                submitting.value = false;
                VXETable.modal.message({ content: error, status: "error" });
                console.log(error);
            });
    }
};
const insertPackageEvent = async () => {
    const { files } = await VXETable.readFile(false);
    Array.from(files).forEach((file) => {
        formInput.formData.fPathPackage = file.name;
        onePackageFile.value = file;
    });
};
const insertPDDEvent = async () => {
    const { files } = await VXETable.readFile(false);
    Array.from(files).forEach((file) => {
        formInput.formData.fPathPdd = file.name;
        onePDDFile.value = file;
    });
};
const insertPhotoEvent = async () => {
    const { files } = await VXETable.readFile(false);
    Array.from(files).forEach((file) => {
        formInput.formData.fPathPhoto = file.name;
        onePhotoFile.value = file;
    });
};

const downloadFile = (type) => {
    proxy.$api.fileManageAPI
        .downloadComponentFile(
            Qs.stringify({
                appId: formInput.formData.Id,
                type: type,
            })
        )
        .then(async (res) => {
            const contentType = res.headers["content-type"] || "";

            // 后端返回错误信息
            if (contentType.includes("application/json")) {
                const text = await res.data.text();

                VXETable.modal.alert({
                    content: text,
                    status: "error",
                });

                return;
            }

            // 获取文件名
            let fileName = "下载文件";

            const disposition =
                res.headers["content-disposition"] ||
                res.headers["Content-Disposition"];

            if (disposition) {
                const utf8Match = disposition.match(
                    /filename\*=UTF-8''([^;]+)/i
                );

                const normalMatch = disposition.match(/filename="?([^"]+)"?/i);

                if (utf8Match?.[1]) {
                    fileName = decodeURIComponent(utf8Match[1]);
                } else if (normalMatch?.[1]) {
                    fileName = normalMatch[1];
                }
            }

            const blob = new Blob([res.data], {
                type: contentType,
            });

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");

            link.href = url;
            link.download = fileName;

            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);

            window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
            console.error(error);

            VXETable.modal.alert({
                content: "文件下载失败",
                status: "error",
            });
        });
};

const checkHasFiles = () => {
    proxy.$api.componentManageAPI
        .checkComponentHasFiles(
            Qs.stringify({
                appId: formInput.formData.Id,
                type: "",
            })
        )
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.alert({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            let fileStatus = res.data.Data.split(",");

            isShowPackageLink.value = fileStatus[0] === "1";
            isShowPDDLink.value = fileStatus[1] === "1";
            isShowPhotoLink.value = fileStatus[2] === "1";
        })
        .catch((error) => {
            console.log(error);
        });
};

const addAuditRecord = (status, type) => {
    let auditBuId = "";
    let auditOpinion = "";
    switch (type) {
        case "1":
            auditBuId = formInput.formData.Id;
            auditOpinion = "";
            break;
    }
    //写审核日志
    const params = {
        auditBuId: auditBuId,
        auditMan: proxy.$store.state.userName,
        auditManUid: proxy.$store.state.userID,
        auditStatus: status, //0发起 1 通过 2 驳回
        auditOpinion: auditOpinion,
        auditNode: "审核发起",
    };
    proxy.$api.requireManageAPI
        .addAuditRecord(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

//提交
const submit = async () => {
    const $rForm = rForm.value;
    const formErrMap = await $rForm.validate();
    if (formErrMap) {
        submitting.value = false;
        return;
    }
    const type = await VXETable.modal.confirm("您确定要提交该数据吗?");
    if (type === "confirm") {
        const data = getModel();

        submitting.value = true;
        proxy.$api.componentManageAPI
            .submitAPP(data)
            .then((res) => {
                if (res.data.Success === false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    submitting.value = false;
                    return;
                }
                VXETable.modal.message({
                    content: "提交成功",
                    status: "success",
                });
                emit("flashIndex");
                // addAuditRecord("0", "1"); //写审核日志
                formInput.isShow = false;
                submitting.value = false;
            })
            .catch((error) => {
                VXETable.modal.message({ content: error, status: "error" });
                submitting.value = false;
                console.log(error);
            });
    }
};

const editAPP = (row) => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 20,
        searchKey: [row.Id],
    };
    proxy.$api.componentManageAPI
        .getComponentOne(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }

            formInput.formData = res.data.Data;
            formInput.formData.publicDivision = (
                formInput.formData.publicDivision || ""
            )
                .split(",")
                .filter(Boolean);
            console.log("editAPP formData:", formInput.formData);
            formInput.formData.appClassId = String(
                formInput.formData.appClassId
            );
            labels.value = labelMap.value[formInput.formData.appClassId];
            formInput.formData.labelId = String(formInput.formData.labelId);
            editType.value = "2"; //新增
            showVersion.value = true;
            isViewFooter.value = true;
            checkHasFiles();
            formInput.title = "修改应用";
            if (formInput.formData.status !== "0") {
                showFileEdit.value = false;
                activeTab.value = "comVersion";
            } else {
                showFileEdit.value = true;
                activeTab.value = "comInfo";
            }

            formInput.isShow = true;
        })
        .catch((error) => {
            console.log(error);
        });
};

const onClassChange = (val) => {
    const classId = String(val.value);
    labels.value = labelMap.value[classId] || [];
    console.log("onClassChange classId:", classId, labels.value);
    formInput.formData.labelId = "";
    if (classId !== "1") {
        //MCP Server
        formInput.formData.mcpServeName = "";
        formInput.formData.isRemote = "0";
        formInput.formRules.mcpServeName[0].required = false;
        formInput.formRules.isRemote[0].required = false;
    } else {
        formInput.formRules.mcpServeName[0].required = true;
        formInput.formRules.isRemote[0].required = true;
    }
};

const tabsKey = ref(0);

onActivated(() => {
    activeTab.value = "comInfo";
    tabsKey.value++; // 强制 remount <a-tabs>
});
onMounted(() => {
    bindClassLabel();
    bindHQ();
});

defineExpose({ addAPP, editAPP });
</script>

<style lang="scss" scoped>
.mytable-style .vxe-body--column.col-red {
    background-color: red;
    color: #fff;
}

.active {
    color: green;
}

.error {
    color: red;
}

.audit {
    color: blue;
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
